export default {
    profile: 'Profile',
    name: 'Name',
    employeeNo: 'Employee No',
    employeeName: 'Employee Name',
    address: 'Address',
    date: 'Date',
    time: 'Time',
    department: 'Department',
    group: 'Group',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
    contact: 'Contact',
    email: 'Email Address',
    phoneNumber: 'Phone Number',
    checkInStatus: 'Check-In Status',
    checkInLocation: 'Location',
    viewAttendance: 'View Attendance',
    attachmentFile: 'Attachment File',
    checkInDetail: 'Detail',
    checkIn: 'Check In',
    jobId: 'Job ID',
    customerName: 'Customer Name',
    contactPerson: 'Customer Person',
    contactPhone: 'Customer Phone',
    origin: 'Origin',
    startTime: 'Start Time',
    startMilieage: 'Start Milieage',
    endTime: 'End Time',
    endMilieage: 'End Milieage',
    activities: 'Activities'
}
